import React from 'react';
import { Button } from '@mui/material';
import { HighlightOff as HighlightOffIcon } from '@mui/icons-material';

interface CancelButtonProps {
  onClick: () => void;
  disabled: boolean;
  color?: string;
  customText?: string;
}

const CancelButton: React.FC<CancelButtonProps> = ({ onClick, disabled, customText = 'Cancel', color = '#273194'}) => {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      sx={{
        color,
        textTransform: 'none',
        maxHeight: '2.5rem'
      }}
    >
      <div style={{display: 'flex', alignItems: 'center', gap: '0.25rem'}}>
        <HighlightOffIcon
          fontSize='small'
        />
        <p>{customText}</p>
      </div>
    </Button>
  );
};

export default CancelButton;
